enum AnnotationSelectorEnum {
	DAILY_PICKS = 'daily_picks',
	ICONS = 'icons',
	BANNERS = 'banners',
	ROBUX_HISTORY = 'robux_history',
}

export default AnnotationSelectorEnum;
